/**
 * Offers an easy API to create transform strings for SVG
 */
export default class Transform {
    transforms = [];

    constructor(transforms = []) {
        this.transforms = transforms;
    }

    _createTransform(transformation, ...args) {
        const transform = `${transformation}(${args.filter(arg => arg !== null).join(' ')})`;
        return new Transform(this.transforms.concat([transform]));
    }

    translate(x, y = null) {
        return this._createTransform('translate', x, y);
    }

    translatePoint({ x, y }) {
        return this.translate(x, y);
    }

    scale(x, y = null) {
        return this._createTransform('scale', x, y);
    }

    rotate(x) {
        return this._createTransform('rotate', x);
    }

    skewX(x) {
        return this._createTransform('skewX', x);
    }

    skewY(y) {
        return this._createTransform('skewY', y);
    }

    skew(x, y) {
        return this.skewX(x).skewY(y);
    }

    toString() {
        return this.transforms.join(' ');
    }
}
